import { TypeOf, yup } from '@guiker/yup-util'

export const backgroundCheckIdPathValidator = yup.object({
  backgroundCheckId: yup.string().required(),
})

export type BackgroundCheckIdPathParam = TypeOf<typeof backgroundCheckIdPathValidator>
